// Import helpers
import { createLinkParams, getImage } from 'helpers';

// Import variables
import { VOD_SECTIONS_TYPES, PRODUCT_IMAGES_TYPES } from 'helpers/variables';

// Import utilities
import { useVodProgress } from 'components/utilities';
import useImageCheck from './useImageCheck';

// Import components
import NoImageSVG from 'components/views/vod/images/placeholder.svg';

const { WEB_MOVIES_CONTINUE_WATCHING } = VOD_SECTIONS_TYPES;
const { LOGO, POSTER } = PRODUCT_IMAGES_TYPES;

const useSliderItemLogic = ({
	sectionLabel = '',
	data: {
		uuid: id,
		images,
		subtype,
		context,
		title,
		year,
		genres,
		rating,
		country
	},
	sliderId = '',
	width,
	height
}) => {
	const itemDetailsData = {
		title,
		year,
		rating,
		genres: genres && genres.length > 0 && genres[0].name,
		country
	};

	const duration = context && context.duration ? context.duration : 0;

	const continuePercent = useVodProgress(id, duration);

	const isContinueWatchingSection =
		sectionLabel === WEB_MOVIES_CONTINUE_WATCHING;

	const isCollectionPage = sliderId === 'collection';

	const isChannel = subtype === 'channel';

	const channelLogo = getImage({ images, types: [LOGO] });
	const productPoster = getImage({ images, types: [POSTER] });

	const imageSrc = isChannel ? channelLogo : productPoster;

	const linkParams = createLinkParams({ id, type: subtype, title });

	const { isError } = useImageCheck(imageSrc);
	const backgroundImage = !isError && imageSrc ? imageSrc : NoImageSVG;

	const isPlaceholder = backgroundImage === NoImageSVG;

	const backgroundSize = isPlaceholder
		? 'cover'
		: isChannel
		? 'contain'
		: `${width}px ${height}px`;

	return {
		itemDetailsData,
		isContinueWatchingSection,
		isCollectionPage,
		backgroundImage,
		linkParams,
		continuePercent,
		backgroundSize
	};
};

export default useSliderItemLogic;
